#import "../fragments/email-lead-associations-fragment.graphql"

mutation UpdateEmailLeadAssociations($input: EmailLeadAssociationsUpdateInput!) {
    emailLeadAssociationsUpdate(input: $input) {
        email {
            ...EmailLeadAssociationsFragment
        }
    }
}
